import {LearnCategory, LearnModule} from "../../api/repositories/learn-repository";
import {captureMessage} from "@sentry/react";

/**
 * Resolve all child categories recursively. Use maxRecursion to prevent crashed with looping category structures.
 * @param categories
 * @param parentCategoryId
 * @param maxRecursion
 */
export function getCategoryChildrenRecursively(categories: LearnCategory[], parentCategoryId: string, maxRecursion = 20): LearnCategory[] {
  if (maxRecursion < 0) {
    console.warn('Reached maximum recursion in getCategoryChildrenRecursively')
    captureMessage('Reached maximum recursion in getCategoryChildrenRecursively', 'warning')
    return []
  }
  const directChildren = categories.filter(c => c.parent_category_id === parentCategoryId)
  return [
    ...directChildren,
    ...directChildren.map((childCategory) => getCategoryChildrenRecursively(categories, childCategory.id, maxRecursion - 1)).flat()
  ]
}

export function getModulesInParentCategories(categories: LearnCategory[], modules: LearnModule[], parentCategoryIds: string[]): LearnModule[] {
  const categoryIdsWithChildCategories = parentCategoryIds
    .map((categoryId) => {
      const current = categories.find(c => c.id === categoryId)
      return [...(current ? [current] : []), ...getCategoryChildrenRecursively(categories, categoryId)];
    })
    .flat()
    .map(category => category.id)
  const uniqueCategories = Array.from(new Set(categoryIdsWithChildCategories))
  return modules.filter(m => m.category_id && uniqueCategories.includes(m.category_id))
}